// extracted by mini-css-extract-plugin
module.exports = {"footer":"style_footer__3G2ET","inner":"style_inner__SGjEC","bottom":"style_bottom__2hL30","copyright":"style_copyright__xtzKc"};